<template>
  <div class="pageWithdrawAccountEdit">
    <XR-head :titleText="pageTitle" :rightShow="false" ref="headObj"></XR-head>
    <div>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-select-field label="提现方式" v-model="bankInfo.bankType"  helpText="请选择您的提现方式" labelFloat fullWidth>
            <!-- <mu-menu-item value="0" title="银行卡"/>
            <mu-menu-item value="1" title="支付宝"/>
            <mu-menu-item value="2" title="财付通"/> -->
            <mu-menu-item v-for="text,index in bankNameList" :key="index" :value="index" :title="text" />
          </mu-select-field>
        </mu-col>
      </mu-row>   
      <mu-row gutter v-if="bankInfo.bankType == 0">
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="银行名称" helpText="请输入提现银行名称" labelFloat fullWidth v-model="bankInfo.bankname" />
           <!--
           <mu-select-field fullWidth v-model="bankInfo.bankname" label="提现银行"  helpText="请选择您的提现银行">
            <mu-menu-item value="" title="选择银行" />
            <mu-menu-item value="工商银行" title="工商银行" />
            <mu-menu-item value="建设银行" title="建设银行" />
            <mu-menu-item value="中国银行" title="中国银行" />
            <mu-menu-item value="农业银行" title="农业银行" />
            <mu-menu-item value="民生银行" title="民生银行" />
            <mu-menu-item value="交通银行" title="交通银行" />
            <mu-menu-item value="招商银行" title="招商银行" />
            <mu-menu-item value="广发银行" title="广发银行" />
            <mu-menu-item value="平安银行" title="平安银行" />
            <mu-menu-item value="兴业银行" title="兴业银行" />
            <mu-menu-item value="中国光大银行" title="中国光大银行" />
          </mu-select-field>
          -->
        </mu-col>
      </mu-row>       
      <mu-row gutter v-if="bankInfo.bankType == 0">
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="支行名称" helpText="请输入银行的支行名称" labelFloat fullWidth v-model="bankInfo.bankaddress" />
        </mu-col>
      </mu-row>        
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="真实姓名" helpText="请输入您账户的姓名" labelFloat fullWidth v-model="bankInfo.bankuser" />
        </mu-col>
      </mu-row>             
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="手机号" helpText="请输入您的联系电话" labelFloat fullWidth v-model="bankInfo.tellphone" />
        </mu-col>
      </mu-row>   
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="帐号/卡号" helpText="请输入您的提现账户或卡号" labelFloat fullWidth v-model="bankInfo.bankno" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="身份证号" helpText="请输入您的身份证号" labelFloat fullWidth v-model="bankInfo.idcard" />
        </mu-col>
      </mu-row>  
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="备注" helpText="请输入备注" labelFloat fullWidth v-model="bankInfo.bk" :maxLength="50" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>  
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>  
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data () {
    return {
      bankNameList:['银行卡','支付宝','财付通'],
      editMode : false,
      pageTitle: this.$route.query.bankId>0?'编辑提现账户':'添加提现账户',
      bankInfo:{
        bankType : -1,
        username : '',
        tellphone : '',
        bankno : '',
        bankname:''
      }
    }
  },
  mounted:function(){    
    if(this.$route.query.bankId>0){        
      this.$refs.XRtoast.load('加载中...')
      this.getBankDetail()
    } else {
      this.bankInfo.bankType = 0;
    }
  },
  methods: {
    getBankDetail: function () {      
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetMemberBankDetail",
        JSON.stringify({bankId:ths.$route.query.bankId})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.hide(false)
          ths.editMode = true
          ths.bankInfo = res.Data
        }
      })      
    },
    submit: function(){
      var ths = this;   
      ths.bankInfo.is_default= 1
	  ths.bankInfo.id= ths.bankInfo.bid
      ths.$post(
        "/Shop/UserServer/EditMemberBank",
        JSON.stringify(ths.bankInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{       
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      })      
    },
    goBack:function(){
      this.$router.goBack()
    }
  }
}
</script>
<style>
.pageWithdrawAccountEdit{
  background: white;
}
.pageWithdrawAccountEdit .rowFiled{
  padding: 0 5%;
}
.pageWithdrawAccountEdit .forgetBtn {
  float: right;
}

.pageWithdrawAccountEdit .btn-div {
  padding: 40px 5% 30px;
}
.pageWithdrawAccountEdit .submit {
  height: 50px;
}
.mu-popover .mu-menu-list .mu-menu-item{border-bottom: 1px solid #f5f5f5}

</style>



// WEBPACK FOOTER //
// src/pages/usercenter/withdrawAccountEdit.vue